(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('editorStructure',{
                parent:'entity',
                url:'/{storeId}/editorStructure',
                data:{
                    authorities: [],
                },
                // 本页是全屏固定布局，隐藏 index.html 中带 30px 上边距的空内容容器，
                // 避免出现页面滚动条导致固定面板偏离设计稿坐标
                onEnter: ['$document', function ($document) {
                    $document[0].body.classList.add('editor-structure-page');
                }],
                onExit: ['$document', function ($document) {
                    $document[0].body.classList.remove('editor-structure-page');
                }],
                views:{
                    'navbar@': {
                        templateUrl: 'app/entities/editor-structure/editor-structure.html',
                        controller: 'EditorStructureController',
                        controllerAs: 'vm'
                    }
                }
            })
        ;
    }

})();
